import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { kargoApiRef, KargoClient } from './api';

const kargoApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: kargoApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new KargoClient({
          discoveryApi,
          fetchApi,
        }),
    }),
});

const kargoPage = PageBlueprint.make({
  params: {
    path: '/kargo',
    title: 'Kargo',
    routeRef: rootRouteRef,
    // The project list and detail pages render their own BUI
    // <FullPage>/<Header>.
    noHeader: true,
    loader: () => import('./components/KargoPage').then(m => <m.KargoPage />),
  },
});

export const kargoPlugin = createFrontendPlugin({
  pluginId: 'kargo',
  title: 'Kargo',
  routes: {
    root: rootRouteRef,
  },
  extensions: [kargoApi, kargoPage],
});

export default kargoPlugin;
